// Column definitions for the Webinar GlobalTable.
// Field names match the LIST endpoint response (see docs/webinar-api.md).
import { Chip, Switch, Tooltip } from '@mui/material';
import { resolveWebinarPoster } from './resolveWebinarPoster';

// `onToggleActive(row, nextValue)` fires the PATCH; `busy` disables every switch
// while one is in flight, because activating a row also deactivates another and
// two overlapping toggles would leave the grid showing a stale winner.
export const WebinarTableHeader = ({ onToggleActive, busy } = {}) => [
  { field: 'sl_no', headerName: 'Sl No', width: 90 },
  { field: 'webinar_id', headerName: 'Webinar Id', width: 120 },
  {
    field: 'poster',
    headerName: 'Poster',
    width: 110,
    renderCell: (params) => {
      const src = resolveWebinarPoster(params.value, params.row?.poster_url);
      return src ? (
        <img
          src={src}
          alt={params.row?.webinar_name || 'poster'}
          style={{ width: 48, height: 40, objectFit: 'cover', borderRadius: 6 }}
        />
      ) : (
        '-'
      );
    },
  },
  { field: 'webinar_name', headerName: 'Webinar Name', width: 300, toolTipGetter: true },
  { field: 'from_date', headerName: 'From Date', width: 140 },
  { field: 'to_date', headerName: 'To Date', width: 140 },
  {
    //DERIVED SERVER SIDE: is_active AND today IS INSIDE THE WINDOW. A WEBINAR CAN
    //BE Active AND STILL NOT SHOWING ON THE PUBLIC SITE BECAUSE ITS DATES HAVE NOT
    //STARTED OR HAVE PASSED - THIS COLUMN IS THE ONLY PLACE THAT DIFFERENCE IS
    //VISIBLE, SO DO NOT DROP IT.
    field: 'is_live',
    headerName: 'On Public Site',
    width: 150,
    renderCell: (params) => {
      if (params.row?.is_live) {
        return <Chip size="small" color="success" label="Live" />;
      }
      if (params.row?.is_active) {
        return <Chip size="small" color="warning" variant="outlined" label="Out of dates" />;
      }
      return <Chip size="small" variant="outlined" label="No" />;
    },
  },
  {
    field: 'createdByName',
    headerName: 'Created By',
    width: 180,
    renderCell: (params) => params.row?.created_user?.name || '-',
    toolTipGetter: true,
  },
  { field: 'created_on', headerName: 'Created On', width: 190, toolTipGetter: true },
  {
    //LAST COLUMN BY REQUEST. THE SWITCH ONLY EVER TURNS ONE WEBINAR ON OR OFF -
    //IT NEVER STEALS THE SLOT, BECAUSE THE API REFUSES A SECOND ACTIVATION AND
    //Webinar.jsx TURNS THAT REFUSAL INTO AN ALERT.
    field: 'is_active',
    headerName: 'Status',
    width: 150,
    renderCell: (params) => (
      <Tooltip
        title={
          params.row?.is_active
            ? 'Active — turn this off to free the slot for another webinar'
            : 'Activate — only allowed while no other webinar is active'
        }
      >
        <span>
          <Switch
            size="small"
            checked={Boolean(params.row?.is_active)}
            disabled={busy}
            onChange={(event) => onToggleActive && onToggleActive(params.row, event.target.checked)}
          />
        </span>
      </Tooltip>
    ),
  },
  {
    field: 'edit',
    headerName: 'Edit',
    type: 'action',
    actionType: 'edit',
    actionKey: 'editWebinar',
    width: 140,
    buttonName: 'Edit',
  },
  {
    field: 'delete',
    headerName: 'Delete',
    type: 'action',
    actionType: 'delete',
    actionKey: 'deleteWebinar',
    width: 150,
    buttonName: 'Delete',
  },
];
